import React from "react"
import QuoteSection from "../quote-section"

const PackageBuilder = ({ ...props }) => (
  <QuoteSection
    className="w-full h-screen"
    title="quote-booking"
    allowFullScreen="allowfullscreen"
    {...props}
  />
)

export default PackageBuilder
